module.exports = "<div class=\"loading\">\n\t<div class=\"loading-inner\">\n\t\t<div class=\"lds-ring\"><div></div></div>\n\t{{message}}\n</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/loading/loading.component.html
// module id = ./client/app/loading/loading.component.html
// module chunks = main